import React, { useCallback, useMemo } from 'react'
import MultipleSelect from 'components/MultipleSelect'
import styles from 'modules/Services/CampaignsEditor/campaigns-editor.module.scss'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

const ColumnSwitcher = ({
  tableState = {},
  buttonProps = { size: 'm', noLabel: false, disabled: false },
}) => {
  const { t } = useTranslation()

  const { visibleColumns, columns } = useMemo(
    () => ({
      visibleColumns: tableState
        .getVisibleFlatColumns()
        .filter((column) => column.getCanHide()),
      columns: tableState
        .getAllColumns()
        .filter((column) => column.getCanHide()),
    }),
    [tableState.getState()],
  )

  const onChange = useCallback(
    (selectionArr) => {
      tableState.setColumnVisibility(() =>
        columns.reduce((acc, column) => {
          acc[column.id] = !column.getCanHide()
            ? true
            : !!selectionArr.includes(column.id)
          return acc
        }, {}),
      )
    },
    [columns, tableState],
  )

  const onReset = useCallback(() => {
    tableState.resetColumnVisibility()
  }, [tableState])

  return !tableState ? null : (
    <MultipleSelect
      buttonProps={buttonProps}
      value={visibleColumns.map(({ id }) => id)}
      values={columns.map((column) => ({
        label: column.columnDef.label ?? column.id,
        value: column.id,
      }))}
      placeholder={t(
        'campaigns_editor::table_switcher.choose_columns_placeholder',
      )}
      listTitle={t('campaigns_editor::table_switcher.choose_columns')}
      apply={t('campaigns_editor::table_switcher.submit')}
      dropSelection={t('campaigns_editor::table_switcher.reset')}
      onChange={onChange}
      onReset={onReset}
      buttonClass={styles['table_switcher-button']}
    />
  )
}

ColumnSwitcher.propTypes = {
  disabled: PropTypes.bool,
  tableState: PropTypes.object,
  buttonProps: PropTypes.object,
}

export default ColumnSwitcher
